import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * Validátor množství RM, pokud se jedná o semenný RM.
 * @param formType
 * @param semennyRm
 */
export function MnozstviSemValidator(formType: string, semennyRm: number): ValidatorFn {

  const zadostPop: string = 'FormZadostPopComponent';
  const zadostPopOddily: string = 'FormZadostPopOddilyComponent';

  /**
   * Vrátí hodnotu druhu RM dle typu formuláře.
   * @param control
   * @param formType
   */
  var _getDruhRm = function (control: AbstractControl, formType: string): number {
    let druhRmControl;
    if (formType == zadostPop) {
      druhRmControl = control?.parent?.get('druhRepMaterialu');
    }
    else if (formType == zadostPopOddily) {
      druhRmControl = control?.parent?.parent?.parent?.get('druhRepMaterialu');
    }

    return druhRmControl?.value != void 0 && druhRmControl?.value != '' ? druhRmControl.value.kod : null;
  }


  return (control: AbstractControl): { [key: string]: any | null } => {
    let druhRmValue = _getDruhRm(control, formType);

    if (druhRmValue != void 0) {
      if (druhRmValue == semennyRm && (control?.value == void 0 || control?.value == '')) {
        return { 'MnozstviError': 'Pokud jde o semenný RM, je potřeba zadat množství materiálu.' };
      }
    }
    return null;
  }
}
